module.exports = __webpack_public_path__ + "static/img/operaingHuman.8c61ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaingHuman.png
// module id = V6JO
// module chunks = 1